var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useMemo, useRef } from 'react';
import ReactModal from 'react-modal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import { get } from 'lodash';
import { Translate } from "../../I18N";
import { Icon } from "../../UI";

import uniqueID from "../../../shared/uniqueID";

import { WebMediaResourceForm } from "../../Attachments/components/WebMediaResourceForm";
import { uploadLocalAttachment } from "../actions/supportingFilesActions";
import { mimeTypeFromUrl } from "../../../api/files/extensionHelper";
import { MediaModalFileList } from "./MediaModalFileList";
import { MediaModalUploadFileButton } from "./MediaModalUploadFileButton";
import { validImageFile, validMediaFile } from "../helpers/validator";var

MediaModalType = /*#__PURE__*/function (MediaModalType) {MediaModalType[MediaModalType["Image"] = 0] = "Image";MediaModalType[MediaModalType["Media"] = 1] = "Media";MediaModalType[MediaModalType["All"] = 2] = "All";return MediaModalType;}(MediaModalType || {});





const getAcceptedFileTypes = (type) => {
  switch (type) {
    case MediaModalType.Image:
      return 'image/*';
    case MediaModalType.Media:
      return 'video/*,audio/*';
    case MediaModalType.All:
    default:
      return '*/*';
  }
};













const mapStateToProps = (state, ownProps) => {
  const model = ownProps.formModel;
  return {
    entity: get(state, model)
  };
};

const mapDispatchToProps = (dispatch) =>
bindActionCreators(
  { localAttachmentAction: uploadLocalAttachment, rrfChange: formActions.change },
  dispatch
);

const connector = connect(mapStateToProps, mapDispatchToProps);




function filterAttachments(
type,
attachments)
{
  const filteredAttachments = attachments.map((a) => {
    const mimetype = a.url && !a.mimetype ? mimeTypeFromUrl(a.url) : a.mimetype;
    return _objectSpread(_objectSpread({}, a), {}, { mimetype });
  });
  switch (type) {
    case MediaModalType.Image:
      return filteredAttachments.filter(validImageFile);
    case MediaModalType.Media:
      return filteredAttachments.filter(validMediaFile);
    default:
      return attachments;
  }
}

const MediaModalComponent = ({
  isOpen,
  attachments = [],
  selectedUrl,
  entity,
  formModel,
  formField,
  type,
  multipleEdition,
  onClose,
  onChange,
  localAttachmentAction,
  rrfChange
}) => {
  const filteredAttachments = useMemo(
    () => filterAttachments(type, attachments),
    [attachments, type]
  );

  const inputFileRef = useRef(null);

  const handleAttachmentClick = (url) => () => {
    onChange(url);
    onClose();
  };

  const handleSubmitFromUrl = (formData) => {
    onChange(formData.url);
    onClose();
  };

  const handleFileInPublicForm = (event) => {
    const { files } = event.target;
    if (files && files.length > 0) {
      const data = { data: URL.createObjectURL(files[0]), originalFile: files[0] };
      onChange(data);
      onClose();
    }
  };

  const handleUploadButtonClicked = () => {var _inputFileRef$current;
    (_inputFileRef$current = inputFileRef.current) === null || _inputFileRef$current === void 0 ? void 0 : _inputFileRef$current.click();
  };

  const handleInputFileChange = async (event) => {
    const [file] = event.target.files || [];

    if (file) {
      const fileLocalID = uniqueID();

      localAttachmentAction(
        entity.sharedId || 'NEW_ENTITY',
        file,
        {
          __reducerKey: 'library',
          model: formModel
        },
        fileLocalID
      );
      rrfChange(formField, fileLocalID);
      onClose();
    }
  };

  return /*#__PURE__*/(
    _jsx(ReactModal, {
      isOpen: isOpen,
      className: "attachments-modal",
      overlayClassName: "attachments-modal__overlay",
      ariaHideApp: false }, void 0, /*#__PURE__*/

    _jsx("div", { className: "attachments-modal__header" }, void 0, /*#__PURE__*/
    _jsx("h4", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Supporting files")
    ), /*#__PURE__*/

    _jsx("button", { type: "button", onClick: onClose, className: "attachments-modal__close" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "times" }), /*#__PURE__*/
    _jsx("span", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Close")
    )
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "attachments-modal__content" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "attachments-modal__tabs-content" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "upload-options" }, void 0,
    !multipleEdition && /*#__PURE__*/
    _jsx(MediaModalUploadFileButton, {
      formModel: formModel,
      acceptedFileTypes: getAcceptedFileTypes(type),
      inputFileRef: inputFileRef,
      handleUploadButtonClicked: handleUploadButtonClicked,
      handleFileInPublicForm: handleFileInPublicForm,
      handleInputFileChange: handleInputFileChange }
    ),

    !multipleEdition && /*#__PURE__*/_jsx(Translate, {}, void 0, "or"), /*#__PURE__*/
    _jsx("div", { className: "wrapper-web" }, void 0, /*#__PURE__*/
    _jsx(WebMediaResourceForm, { handleSubmit: handleSubmitFromUrl })
    )
    ), /*#__PURE__*/
    _jsx("div", {
      className: `tab-content attachments-modal__tabs-content ${
      !filteredAttachments.length ? 'centered' : ''
      }` }, void 0, /*#__PURE__*/

    _jsx(MediaModalFileList, {
      filteredAttachments: filteredAttachments,
      handleAttachmentClick: handleAttachmentClick,
      selectedUrl: selectedUrl || '' }
    )
    )
    )
    )
    ));

};

const container = connector(MediaModalComponent);


export { MediaModalType, container as MediaModal };